<template>
  <CContainer class="d-flex content-center min-vh-100">

    <b-row class="justify-content-center" no-gutters>
      <b-col>
        <b-card no-body class="p-4 mx-5 mx-sm-0">
          <b-card-body>
            <b-form validated @submit.prevent="handleSigninUser" autocomplete="new-password">
              {{ $store.state.accessToken }}
              <h1 class="text-center"><i class="fa fa-user pr-2"></i>Sign in</h1>
              <!-- 
              <b-row class="nopadding mt-2 mb-0 background-transparent" no-gutters>
                <b-col>

                </b-col>
              </b-row> -->
              <b-row no-gutters class="mt-4 text-center">
                <b-col>
                  <b-button type="submit" variant="ms2" class="" @click="handleSigninMS()">
                    <b-img class
                      :src="$store.state.darkMode ? '/img/brand/ms-symbollockup_signin_dark.png' : '/img/brand/ms-symbollockup_signin_light.png'"></b-img>
                  </b-button>
                </b-col>
              </b-row>

              <p v-if="!showcredentials" class="mt-3 text-center text-muted">Or <b-link
                  @click="showcredentials = !showcredentials">click here
                </b-link> to use your BOP credentials.
              </p>

              <b-row class="nopadding mt-4 mb-0 background-transparent w-100pct" no-gutters>
                <div class="w-100pct" v-show="showcredentials">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="fa fa-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="email" id="normalEmail" required v-model="email" :disabled="busy"
                      placeholder="Enter Email" autocomplete="new-password" />
                    <b-form-invalid-feedback id="usernameFeedback">Email is required</b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="fa fa-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="password" id="normalPass" required v-model="password" :disabled="busy"
                      placeholder="Enter Password" autocomplete="new-password" />
                    <b-form-invalid-feedback id="passwordFeedback">Password is required</b-form-invalid-feedback>
                  </b-input-group>
                  <div v-if="error">
                    <b-alert variant="danger" show>{{ error.message }}</b-alert>
                  </div>
                  <b-row align-v="center" no-gutters>
                    <b-col>
                      <b-button type="submit" variant="primary" class="px-4" @click="handleSigninUser()">Sign
                        in</b-button>&nbsp;
                      <img v-show="busy"
                        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    </b-col>
                    <b-col class="text-right">
                      <router-link class="pl-0" to="/reset?action=forgot">Forgot
                        password?</router-link>
                    </b-col>
                  </b-row>
                </div>
              </b-row>

            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </CContainer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Signin",
  data() {
    return {
      message: null,
      email: "",
      password: "",
      account: null,
      showcredentials: false
    };
  },
  computed: {
    ...mapGetters(["busy", "error", "user"]),
  },
  watch: {
    user: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          this.$router.push("/");
        }
      }
    }
  },
  methods: {
    async handleSigninMS() {
      this.$store.dispatch("signinMS")
    },
    handleSigninUser() {
      this.$store.dispatch("signinUser", {
        email: this.email,
        password: this.password,
      });
    },
  },
};
</script>
